module.exports = __webpack_public_path__ + "img/logo.41d045c5.png";